import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const routes = [
    {
        path: "",
        component: () => import("@/layouts/Main.vue"),
        children: [
            {
                path: "/",
                name: "home",
                redirect: { name: "accounts" },
                meta: {
                    rule: "*"
                }
            },
            {
                path: "/users-management",
                name: "users-management",
                redirect: { name: "users" },
                meta: {
                    rule: "viewUsers"
                }
            },
            {
                path: "/users-management/users",
                name: "users",
                component: () => import("@/views/user/UserList.vue"),
                meta: {
                    rule: "viewUsers",
                    parent: "users-management"
                }
            },
            {
                path: "/accounts",
                name: "accounts",
                component: () => import("@/views/account/AccountList.vue"),
                meta: {
                    rule: "viewAccounts"
                }
            },
            {
                path: "/duplication",
                name: "duplication",
                component: () => import("@/views/duplication/Main.vue"),
                meta: {
                    rule: "viewDuplication"
                }
            },
            {
                path: "/cheats/count",
                name: "cheatCount",
                component: () => import("@/views/cheat/ChatCount.vue"),
                meta: {
                    rule: ['*'],
                    parent: "accounts"
                }
            },
            {
                path: "/cheats/search",
                name: "cheatSearch",
                component: () => import("@/views/cheat/ChatSearch.vue"),
                meta: {
                    rule: ['*'],
                    parent: "accounts"
                }
            },
            {
                path: "/cheats/detail",
                name: "cheatDetail",
                component: () => import("@/views/cheat/CheatDetail.vue"),
                meta: {
                    rule: ['*']
                }
            },
            {
                path: "/under",
                name: "under",
                component: () => import("@/views/Under.vue"),
                meta: {
                    rule: "viewUnder"
                }
            },
            {
                path: "/cheat-ip",
                name: "cheatip",
                component: () => import("@/views/CheatIP.vue"),
                meta: {
                    rule: "viewCheatIP"
                }
            },
            {
                path: "/black-ip",
                name: "blackip",
                component: () => import("@/views/blackIp/BlackListIP.vue"),
                meta: {
                    rule: "viewBlackIP"
                }
            },
            {
                path: "/bets/other-count",
                name: "other-count",
                component: () => import("@/views/bet/OtherSportCount.vue"),
                meta: {
                    rule: "viewOtherSport"
                }
            },
            {
                path: "/bets/other-detail",
                name: "other-detail",
                component: () => import("@/views/bet/OtherSportDetail.vue"),
                meta: {
                    rule: "viewOtherSport",
                    parent: "other-count"
                }
            },
            {
                path: "/tools",
                name: "tools",
                redirect: { name: "winloss" },
                meta: {
                    rule: "viewWinloss"
                }
            },
            {
                path: "/tools/winloss",
                name: "winloss",
                component: () => import("@/views/tools/Winloss.vue"),
                meta: {
                    rule: "viewWinloss",
                    parent: "tools"
                    // breadcrumb: [
                    //     { title: 'Home', url: '/' },
                    //     { title: 'Tools', url: '/tools'},
                    //     { title: 'Winloss', active: true }
                    // ],
                }
            },
            {
                path: "/tools/query",
                name: "query",
                component: () => import("@/views/tools/Query.vue"),
                meta: {
                    rule: "viewQuery",
                    parent: "tools"
                    // breadcrumb: [
                    //     { title: 'Home', url: '/' },
                    //     { title: 'Tools', url: '/tools'},
                    //     { title: 'Query', active: true }
                    // ],
                }
            },
            {
                path: "/tools/query_sap_gia",
                name: "query_sap_gia",
                component: () => import("@/views/tools/QuerySapGia.vue"),
                meta: {
                    rule: "viewQuery",
                    parent: "tools"
                    // breadcrumb: [
                    //     { title: 'Home', url: '/' },
                    //     { title: 'Tools', url: '/tools'},
                    //     { title: 'Query', active: true }
                    // ],
                }
            },
            {
                path: "/tools/find_sap_gia",
                name: "find_sap_gia",
                component: () => import("@/views/tools/FindSapGia.vue"),
                meta: {
                    rule: "viewFindSapGia",
                    parent: "tools"
                    // breadcrumb: [
                    //     { title: 'Home', url: '/' },
                    //     { title: 'Tools', url: '/tools'},
                    //     { title: 'Query', active: true }
                    // ],
                }
            },
            {
                path: "/tools/member_dup",
                name: "member_dup",
                component: () => import("@/views/tools/MemberDup.vue"),
                meta: {
                    rule: "viewMemberDup",
                    parent: "tools"
                    // breadcrumb: [
                    //     { title: 'Home', url: '/' },
                    //     { title: 'Tools', url: '/tools'},
                    //     { title: 'MemberDup', active: true }
                    // ],
                }
            }
        ],
        meta: {
            rule: ['*']
        }
    },
    {
        path: "/login",
        component: () => import("@/views/Login.vue"),
        meta: {
            rule: ['*'],
            authPage: true
        }
    },
    {
        path: "/view-guest-report",
        component: () => import("@/views/GuestReport.vue"),
        meta: {
            rule: ['*']
        }
    },
    {
        path: "/404",
        component: () => import("@/views/404.vue"),
        meta: {
            rule: ['*']
        }
    }
];

const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    routes,
});

router.afterEach(() => {
    // Remove initial loading
    const appLoading = document.getElementById("loading-bg");
    if (appLoading) {
        appLoading.style.display = "none";
    }
});

router.beforeEach((to, from, next) => {
    const loggedIn = localStorage.getItem("userInfo");

    if((to.fullPath == "/view-guest-report")){
        next();
        return;
    }

    if (!to.matched.some((record) => record.meta.authPage) && !loggedIn) {
        next("/login");
        return;
    }

    next();
});

export default router;
